import React, { useContext, useState, useEffect } from 'react';
import { AppContext } from '../App';
import { callApi, callGameServerApi, getInlineLoader, isAlphanumeric, resolveOrientation } from '../Helpers';
import { IoEnterOutline } from 'react-icons/io5';
import TopBar from '../components/TopBar';
import SwipeTabs from '../components/SwipeTabs';
import { copyText, formatDate } from '../Helpers';
import { GAME_TYPES } from '../Constants';

export default function View(props) {
  const appContext = useContext(AppContext);
  const requiredOrientation = "portrait";
  const [ myLeagues, setMyLeagues ] = useState([]);
  const [ availableLeagues, setAvailableLeagues ] = useState([]);
  const [ ready, setReady ] = useState(false);
  const [ loading, setLoading ] = useState(false);

  const getLeagues = () => {
    return new Promise(async resolve => {
      setLoading(true);
      // await callApi('get_user_leagues.php', {}).then(response => {
      await callGameServerApi('get-user-leagues', {}).then(response => {
        setLoading(false);
        if(response.status === 1) {
          setMyLeagues(response.myLeagues);
          setAvailableLeagues(response.availableLeagues);
          resolve();
        } else {
          appContext.tellError('Could not fetch matches');
          appContext.tellError(response.msg)
        }
      })
    })
  }

  const init = async () => {
    appContext.changeOrientation(requiredOrientation);
    await getLeagues().then(() => {
      setReady(true);
    })
  }


  useEffect(() => {
    if(appContext.auth) {
      //initialize
      init();
    } else {
      //take to common area
      appContext.openLogin();
    }
  }, []);

  useEffect(() => {
    if(ready) {
      appContext.setShowOverlayLoader(false);
    }
  }, [ ready ]);

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);
  }, [ loading ]);

  if(ready) {
    return (
      <>
        <TopBar title="Leagues"/>
        <div className="FullPane" id="_fullPane1" data-support-top-bar={true}>
          <SwipeTabs
            tabs={[
              {
                id: 'my_leagues',
                title: 'My Leagues',
                view: (
                  <div className="container-fluid">
                    <h5 style={{ marginBottom: "20px",  marginTop: "30px" }} className="font-light text-muted">My Leagues ({myLeagues.length})</h5>
                    {
                      (myLeagues && myLeagues.length > 0) ?
                      myLeagues.map((item, i) => {
                        return (
                          <div className="text-start z-depth-1" style={{ padding: "10px", marginBottom: "20px" }} key={i}>
                            <div className="d-flex justify-content-between">
                              <h3>
                                {item.uid}<br/>
                                <small style={{ fontSize: "12px" }} className="text-muted">League ID</small>
                                <hr/>

                                <span className='font-light text-bluish' style={{ fontSize: "20px" }}>{item.title}</span><br/>
                                <span className='font-bold text-muted' style={{ fontSize: "15px" }}>
                                  {
                                    (item.gameType === GAME_TYPES.ARUBASTINI) ?
                                    "Cards - Arubastini": ""
                                  }

                                  {
                                    (item.gameType === GAME_TYPES.LASTCARD) ?
                                    "Cards - LastCard": ""
                                  }

                                  {
                                    (item.gameType === GAME_TYPES.BRAZILIAN_CHECKERS) ?
                                    "Brazilian Checkers": ""
                                  }

                                  {
                                    (item.gameType === GAME_TYPES.SPANISH_CHECKERS) ?
                                    "Spanish Checkers": ""
                                  }
                                  
                                </span><br/>
                              </h3>
                              <small className="text-muted font-light">#{(myLeagues.length) - (i)}</small>
                            </div>
                            <h6 className="font-light text-goldish" style={{ marginTop: "20px" }}>
                              {item.status}<br/>
                              <small style={{ fontSize: "12px" }} className="text-muted">League status</small>
                            </h6>

                            <div className="text-end">
                              <button
                                onClick={() => { appContext.navTo({
                                  item: 'view',
                                  subItem: 'browse_league',
                                  extraItem: item.uid,
                                });}}
                                className="btn btn-rounded btn-sm text-goldish">View League</button>

                              <button onClick={() => { copyText(item.uid); appContext.tellMessage("League ID was copied")}} className="btn btn-rounded btn-sm bg-dark text-light">Copy ID</button>
                            </div>
                          </div>
                        );
                      })
                      :""
                    }
                  </div>
                ),
              },
              {
                id: 'available_leagues',
                title: 'Available Leagues',
                view: (
                  <div className="container-fluid">
                    <h5 style={{ marginBottom: "20px",  marginTop: "30px" }} className="font-light text-muted">Available Leagues ({availableLeagues.length})</h5>
                    {
                      (availableLeagues && availableLeagues.length > 0) ?
                      availableLeagues.map((item, i) => {
                        return (
                          <div className="text-start z-depth-1" style={{ padding: "10px", marginBottom: "20px" }} key={i}>
                            <div className="d-flex justify-content-between">
                              <h3>
                                {item.uid}<br/>
                                <small style={{ fontSize: "12px" }} className="text-muted">League ID</small>
                                <hr/>

                                <span className='font-light text-bluish' style={{ fontSize: "20px" }}>{item.title}</span><br/>
                                <span className='font-bold text-muted' style={{ fontSize: "15px" }}>
                                  {
                                    (item.gameType === GAME_TYPES.ARUBASTINI) ?
                                    "Cards - Arubastini": ""
                                  }

                                  {
                                    (item.gameType === GAME_TYPES.LASTCARD) ?
                                    "Cards - LastCard": ""
                                  }

                                  {
                                    (item.gameType === GAME_TYPES.BRAZILIAN_CHECKERS) ?
                                    "Brazilian Checkers": ""
                                  }

                                  {
                                    (item.gameType === GAME_TYPES.SPANISH_CHECKERS) ?
                                    "Spanish Checkers": ""
                                  }
                                  
                                </span><br/>
                              </h3>
                              <small className="text-muted font-light">#{(myLeagues.length) - (i)}</small>
                            </div>
                            <h6 className="font-light text-goldish" style={{ marginTop: "20px" }}>
                              {item.status}<br/>
                              <small style={{ fontSize: "12px" }} className="text-muted">League status</small>
                            </h6>

                            <div className="text-end">
                              <button
                                onClick={() => { appContext.navTo({
                                  item: 'view',
                                  subItem: 'browse_league',
                                  extraItem: item.uid,
                                });}}
                                className="btn btn-rounded btn-sm text-goldish">View League</button>

                              <button onClick={() => { copyText(item.uid); appContext.tellMessage("League ID was copied")}} className="btn btn-rounded btn-sm bg-dark text-light">Copy ID</button>
                            </div>
                          </div>
                        );
                      })
                      :""
                    }
                  </div>
                ),
              }
            ]}
          />
        </div>
      </>
    )
  } else {
    return (
      <div className="FullPane">
        {getInlineLoader()}
      </div>
    )
  }
}
